export default {
  getOrganizationConfig: state => state.config,
}
